import * as React from "react";
import { useAuth } from "@clerk/clerk-react";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/store";

export default function AppLayout() {
  const { userId, isLoaded } = useAuth();
  const navigate = useNavigate();
  const { mobileToken } = useSelector((state: RootState) => state.session);

  React.useEffect(() => {
    if (isLoaded && !userId && !mobileToken) {
      navigate("/login");
    }
  }, [isLoaded, userId, navigate, mobileToken]);

  if ((!isLoaded || !userId) && !mobileToken) return null;

  return <Outlet />;
}
